<template>
  <b-modal v-model="modal" :title="title" size="lg" :no-enforce-focus="true" :no-close-on-backdrop="true">
    <loading :active.sync="loading" color="#556ee6" loader="dots" :is-full-page="false"></loading>
    <div class="row">
      <div class="col-lg-12">
        <form @submit.prevent="saveTask()" autocomplete="off">
          <!-- Bloqueio alvo -->
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label>Bloqueio aéreo a aplicar <span class="text-danger">*</span></label>
                <multiselect
                  v-model="selectedBlock"
                  placeholder="Selecione um bloqueio"
                  label="name"
                  track-by="id"
                  :options="availableBlocks"
                  :allow-empty="false"
                  :class="{ 'is-invalid': submitted && !selectedBlock }"
                >
                  <template slot="option" slot-scope="props">
                    <div class="d-flex justify-content-between">
                      <span>
                        <strong>{{ props.option.name }}</strong>
                        <span v-if="!props.option.group_id" class="badge bg-info text-light ml-1">Global</span>
                      </span>
                      <small class="text-muted">{{ props.option.items_count || 0 }} voo(s)</small>
                    </div>
                  </template>
                </multiselect>
                <div v-if="submitted && !selectedBlock" class="text-danger small mt-1">Selecione um bloqueio.</div>
              </div>
            </div>
          </div>

          <hr>

          <!-- Filtros de participantes -->
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label>Destinatários <span class="text-danger">*</span></label>
                <select v-model="task.type_contact" class="custom-select" :class="{ 'is-invalid': submitted && $v.task.type_contact.$error }">
                  <option value="">Selecione...</option>
                  <option value="guests">Convidados</option>
                  <option value="registered">Inscritos</option>
                </select>
                <div v-if="submitted && !$v.task.type_contact.required" class="invalid-feedback">
                  O campo é obrigatório.
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label>Filtrar por</label>
                <select class="custom-select" v-model="task.type_filter" @change="setFilterTask()">
                  <option value="">Todos</option>
                  <option value="group">Grupo</option>
                  <option value="status">Status</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row" v-if="task.type_filter === 'group'">
            <div class="col-sm-12">
              <div class="form-group">
                <label>Grupos</label>
                <multiselect tag-placeholder="Selecione" placeholder="Selecione um ou mais grupos" v-model="task.groups" label="name" track-by="id" :options="groups" :multiple="true"></multiselect>
              </div>
            </div>
          </div>

          <div class="row" v-if="task.type_filter === 'status'">
            <div :class="hasPendenteSelected ? 'col-sm-6' : 'col-sm-12'">
              <div class="form-group">
                <label>Status</label>
                <multiselect tag-placeholder="Selecione" placeholder="Selecione um ou mais status" v-model="task.status" :options="statusSelect" track-by="id" label="name" :multiple="true"></multiselect>
              </div>
            </div>
            <div class="col-sm-6" v-if="hasPendenteSelected">
              <div class="form-group">
                <label>Tipo Pendência (Sub-status)</label>
                <multiselect tag-placeholder="Selecione" placeholder="Selecione um ou mais sub-status" v-model="task.ref_status" :options="refStatusOptions" track-by="id" label="name" :multiple="true"></multiselect>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label>Tags (opcional — filtro adicional OR)</label>
                <multiselect tag-placeholder="Selecione" placeholder="Selecione uma ou mais tags" v-model="task.tags" label="name" track-by="id" :options="tags" :multiple="true"></multiselect>
                <small class="text-muted">Se informado, inclui apenas participantes com pelo menos uma das tags selecionadas.</small>
              </div>
            </div>
          </div>

          <!-- Contador -->
          <div class="count-box" v-if="task.type_contact">
            <i class="bx bx-group"></i>
            <span v-if="countLoading"><i class="bx bx-loader-alt bx-spin"></i> Calculando...</span>
            <span v-else-if="participantCount > 0"><strong>{{ participantCount }}</strong> {{ participantCount === 1 ? 'participante' : 'participantes' }} serão afetados</span>
            <span v-else class="text-warning">Nenhum participante encontrado com os filtros selecionados</span>
          </div>

          <div v-if="selectedBlock" class="info-box mt-2">
            <i class="mdi mdi-airplane"></i>
            Bloqueio <strong>{{ selectedBlock.name }}</strong> possui {{ selectedBlock.items_count || 0 }} voo(s). A dedup é automática — voos já existentes serão pulados.
          </div>
        </form>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close()">Cancelar</b-button>
      <b-button variant="primary" @click="saveTask()" :disabled="saving || countLoading || participantCount === 0 || !selectedBlock">
        {{ saving ? 'Executando...' : 'Executar' }}
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import Multiselect from 'vue-multiselect'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { countParticipants } from './services'
import flightBlockServices from '@/pages/settings/flight-blocks/services'

export default {
  components: { Loading, Multiselect },
  data () {
    return {
      title: 'Aplicar bloqueio aéreo em massa',
      loading: false,
      saving: false,
      submitted: false,
      participantCount: 0,
      countLoading: false,
      countTimer: null,
      availableBlocks: [],
      selectedBlock: null,
      task: {
        type_contact: '',
        type_filter: '',
        groups: [],
        status: [],
        ref_status: [],
        tags: []
      },
      modal: false
    }
  },
  validations: {
    task: {
      type_contact: { required }
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('settings', ['statusSelect', 'refstatusList']),
    ...mapState('group', ['groups']),
    ...mapState('tag', ['tags']),
    hasPendenteSelected () {
      return this.task.status && this.task.status.some(s => parseInt(s.id) === 2)
    },
    refStatusOptions () {
      if (!this.refstatusList || typeof this.refstatusList !== 'object') return []
      return Object.entries(this.refstatusList).map(([id, name]) => ({ id: parseInt(id), name }))
    }
  },
  methods: {
    ...mapActions('taskFlightBlock', { postData: 'save' }),
    ...mapActions('settings', { GetStatus: 'GetStatusSelect', GetRefStatus: 'GetRefStatusList' }),
    ...mapActions('group', { getAllGroups: 'getAll' }),
    ...mapActions('tag', { getAllTags: 'getAll' }),
    async loadBlocks () {
      try {
        const res = await flightBlockServices.list({ is_active: 1, limit: 500 })
        this.availableBlocks = (res.data && res.data.data) ? res.data.data : []
      } catch (err) {
        this.availableBlocks = []
      }
    },
    getGroups () {
      this.getAllGroups({ status: 1, limit: 100, page: 1 }).catch(err => console.log(err))
    },
    getTags () {
      if (this.getAllTags) {
        this.getAllTags({ limit: 500, page: 1 }).catch(err => console.log(err))
      }
    },
    setFilterTask () {
      this.task.groups = []
      this.task.status = []
      this.task.ref_status = []
      this.fetchCount()
    },
    fetchCount () {
      if (this.countTimer) clearTimeout(this.countTimer)
      if (!this.task.type_contact) {
        this.participantCount = 0
        return
      }
      this.countTimer = setTimeout(() => {
        this.countLoading = true
        const payload = {
          type_contact: this.task.type_contact,
          type_filter: this.task.type_filter || '',
          status: this.task.status ? JSON.stringify(this.task.status) : '[]',
          groups: this.task.groups ? JSON.stringify(this.task.groups) : '[]',
          ref_status: this.task.ref_status ? JSON.stringify(this.task.ref_status) : '[]'
        }
        countParticipants(payload).then(res => {
          this.participantCount = res.data.count || 0
          this.countLoading = false
        }).catch(() => {
          this.participantCount = 0
          this.countLoading = false
        })
      }, 400)
    },
    open () {
      this.modal = true
      this.loading = true
      this.loadBlocks()
      this.getGroups()
      this.getTags()
      this.GetStatus()
      this.GetRefStatus()
      this.loading = false
    },
    async saveTask () {
      this.submitted = true
      this.$v.task.$touch()
      if (this.$v.task.$invalid || !this.selectedBlock) {
        return
      }
      if (this.participantCount === 0) {
        errorMessage('Nenhum participante encontrado com os filtros selecionados.')
        return
      }

      this.saving = true
      this.loading = true

      const payload = {
        type_contact: this.task.type_contact,
        type_filter: this.task.type_filter || '',
        target_flight_block_id: this.selectedBlock.id,
        status: this.task.status ? JSON.stringify(this.task.status) : '[]',
        groups: this.task.groups ? JSON.stringify(this.task.groups) : '[]',
        ref_status: this.task.ref_status ? JSON.stringify(this.task.ref_status) : '[]',
        tags: this.task.tags ? JSON.stringify(this.task.tags) : '[]'
      }

      try {
        await this.postData(payload)
        successMessage('Ação registrada com sucesso. Em minutos os voos serão aplicados.', 2500)
        this.$v.$reset()
        this.$emit('created')
        this.close()
      } catch (err) {
        const msg = (err.response && err.response.data && err.response.data.message) || err.message || 'Erro ao executar.'
        errorMessage('Alerta: ' + msg)
      } finally {
        this.loading = false
        this.saving = false
      }
    },
    close () {
      this.modal = false
      this.submitted = false
      this.saving = false
      this.participantCount = 0
      this.selectedBlock = null
      this.task = {
        type_contact: '',
        type_filter: '',
        groups: [],
        status: [],
        ref_status: [],
        tags: []
      }
      this.$v.$reset()
    }
  },
  watch: {
    modal () {
      if (!this.modal) this.close()
    },
    'task.type_contact' () { this.fetchCount() },
    'task.groups' () { this.fetchCount() },
    'task.status' () { this.fetchCount() },
    'task.ref_status' () { this.fetchCount() }
  }
}
</script>
<style scoped>
.vld-overlay.is-full-page {
  z-index: 1051 !important;
}
.count-box {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #f4f5f7;
  border-radius: 6px;
  font-size: 14px;
  color: #495057;
  margin-top: 4px;
}
.count-box i.bx-group {
  font-size: 18px;
  color: #556ee6;
}
.info-box {
  padding: 10px 14px;
  background: #eef4ff;
  border-left: 3px solid #556ee6;
  border-radius: 4px;
  font-size: 13px;
  color: #495057;
}
.info-box i {
  color: #556ee6;
  margin-right: 4px;
}
</style>
